export default "__VITE_ASSET__06918064__"